import { defineStore } from 'pinia'

export const useHomeStore = defineStore("home", {
  state: () => ({
    boutiqueReport: [
      {
        label: "中国正极材料市场报告",
        cover: require("@/assets/img/cover/zhengjicailiao.png"),
        pdfUrl: "/pdf/2022nianbao/xincailiao/zhengjicailiao.pdf",
      },
      {
        label: "中国铝市场报告",
        cover: require("@/assets/img/cover/dianjielv.png"),
        pdfUrl: "/pdf/2022nianbao/youse/dianjielv.pdf",
      },
      {
        label: "中国沥青市场报告",
        cover: require("@/assets/img/cover/liqing.png"),
        pdfUrl: "/pdf/2022nianbao/nengyuan/liqing.pdf",
      },
      {
        label: "中国氟化工市场年度报告",
        cover: require("@/assets/img/cover/zhilengji.png"),
        pdfUrl: "/pdf/2022nianbao/huagong/zhilengji.pdf",
      },
      {
        label: "中国光伏市场报告",
        cover: require("@/assets/img/cover/guangfu.png"),
        pdfUrl: "/pdf/2022nianbao/xincailiao/guangfu.pdf",
      },
      {
        label: "中国农药市场报告",
        cover: require("@/assets/img/cover/nongyao.png"),
        pdfUrl: "/pdf/2022nianbao/nonghua/nongyaochucaoji.pdf",
      },
      {
        label: "中国黑色金属市场报告",
        cover: require("@/assets/img/cover/heisejinshu.png"),
        pdfUrl: "/pdf/2022nianbao/gangtie/heisejinshu.pdf",
      },
    ],
    list: [
      {
        categoryName: "化工",
        enCategoryName: "chemical industry",
        bgUrl: "bg_hg@2x.png",
      },
      {
        categoryName: "农业",
        enCategoryName: "bg_ny",
        bgUrl: "bg_ny@2x.png",
      },
      {
        categoryName: "能源",
        enCategoryName: "energy",
        bgUrl: "bg_nyy@2x.png",
      },
      {
        categoryName: "有色",
        enCategoryName: "Colored",
        bgUrl: "bg_ys@2x.png",
      },
      {
        categoryName: "橡塑",
        enCategoryName: "Rubber and plastic",
        bgUrl: "bg_xs@2x.png",
      },
      {
        categoryName: "钢铁",
        enCategoryName: "steel",
        bgUrl: "bg_gt@2x.png",
      },
      {
        categoryName: "新材料",
        enCategoryName: "New materials",
        bgUrl: "bg_xcl@2x.png",
      },
      {
        categoryName: "聚氨酯",
        enCategoryName: "polyurethane",
        bgUrl: "bg_jaz@2x.png",
      },
      {
        categoryName: "非金建材",
        enCategoryName: "Non gold building materials",
        bgUrl: "bg_fjjc@2x.png",
      },
      {
        categoryName: "农化",
        enCategoryName: "agrochemical",
        bgUrl: "bg_nh@2x.png",
      },
      {
        categoryName: "纸品",
        enCategoryName: "Paper products",
        bgUrl: "bg_zp@2x.png",
      },
      {
        categoryName: "煤化工",
        enCategoryName: "coal chemical industry",
        bgUrl: "bg_mhg@2x.png",
      },
    ]
  })
})